import React from 'react'
// components
import { Button, BUTTON_LAYOUTS, CREATE_BUTTON_STYLE } from 'components/UI'
// contexts
import { ApiTokensPageContext } from 'containers/ApiTokens/layers/API'

const CreateAPITokenButton = () => {
  const { createApiToken, isLoading } = React.useContext(ApiTokensPageContext)

  return (
    <Button style={CREATE_BUTTON_STYLE} layout={BUTTON_LAYOUTS.PURPLE} disabled={isLoading} onClick={createApiToken}>
      Issue Token
    </Button>
  )
}

export default CreateAPITokenButton
